import React, { useEffect } from 'react';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import { translations } from 'src/constants/translations';
import { primarySelectionTags } from 'src/components/profileComponents/Marketplace/components/Filters/constants';
import {
  ActionButtons,
} from 'src/components/profileComponents/Marketplace/components/Filters/components/ActionButtons';
import { SubGroupWrapper } from 'src/components/profileComponents/Marketplace/components/SubGroupWrapper';
import {
  ComplexTileTags,
} from 'src/components/profileComponents/Marketplace/components/ProjectsTiles/compopents/ComplexTileTags';
import { IMarketplaceTilesConfigComplex } from 'src/typings/marketplace';
import { ReactSortable, Sortable, Store } from 'react-sortablejs';
import { GalleryTile } from 'src/components/profileComponents/Marketplace/components/ProjectsTiles/compopents/GalleryTile';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import {
  GroupWrapperCollapseState,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction/types';
import { useStyles as mainUseStyles } from 'src/components/profileComponents/Marketplace/components/Common/styles';
import { useStyles } from './styles';

interface Props {
  item: IMarketplaceTilesConfigComplex;
  lang: string;
  removeTag: (tagIndex: number) => void;
  addTag: () => void;
  updateComplex: (complex: IMarketplaceTilesConfigComplex) => void;
  isDragging: boolean;
}
export const ComplexTile: React.FC<Props> = ({
  item, lang, removeTag, addTag, updateComplex, isDragging,
}) => {
  const styles = useStyles();
  const mainStyles = mainUseStyles();
  const [collapseState, setCollapseState] = React.useState<GroupWrapperCollapseState>(GroupWrapperCollapseState.OPEN);
  const [rocketState, setRocketState] = React.useState<boolean>(item.isActive);
  const onTrash = () => {};

  useEffect(() => {
    setCollapseState(isDragging ? GroupWrapperCollapseState.CLOSED : GroupWrapperCollapseState.OPEN);
  }, [isDragging]);

  const rocketChange = (state: boolean) => {
    updateComplex({ ...item, isActive: state });
    setRocketState(state);
  };

  return (
    <div className={styles.complexTileWrapper}>
      <GroupWrapper
        name={item.complex.title?.[lang || '']}
        customStyles={!rocketState ? mainStyles.customGroupWrapperStyles : undefined}
        actions={(
          <GroupWrapperFiltersAction
            collapseState={collapseState}
            rocketState={rocketState}
            onDrag={() => {}}
            onRocket={rocketChange}
            onCollapse={(state) => {
              if (!isDragging) {
                setCollapseState(state);
              }
            }}
          />
        )}
      >
        {collapseState === GroupWrapperCollapseState.OPEN && (
          <>
            <div className={styles.title}>
              { translations.editGallery }
            </div>
            <GalleryTile complex={item} onTrash={onTrash} />
            <div className={styles.title}>
              { translations.addProjectTileTags }
            </div>
            <div className={styles.tileTag}>
              <ActionButtons
                buttons={primarySelectionTags}
                onClick={addTag}
              />
            </div>
            <ReactSortable
              animation={150}
              handle=".drag-handle"
              list={item.tags.map((tag) => ({ ...tag, chosen: false }))}
              setList={(newList, sortable: Sortable | null, store: Store) => {
                if (store && store.dragging && store.dragging.props && JSON.stringify(store.dragging.props.list) !== JSON.stringify(newList)) {
                  const orderedList = newList.map((listItem, index) => ({ ...listItem, sortOrder: index }));
                  updateComplex({ ...item, tags: orderedList });
                }
              }}
            >
              {item.tags.map((tag, tagIndex) => (
                <div key={tag.id}>
                  <SubGroupWrapper
                    name="Tile tag"
                    onTrash={() => removeTag(tagIndex)}
                  >
                    <ComplexTileTags
                      item={tag}
                      lang={lang}
                      onChange={(updatedTag) => updateComplex({
                        ...item,
                        tags: item.tags.map((currentTag) => (currentTag.id === updatedTag.id ? updatedTag : currentTag)),
                      })}
                    />
                  </SubGroupWrapper>
                </div>
              ))}
            </ReactSortable>
          </>
        )}

      </GroupWrapper>
    </div>
  );
};
